import React from 'react'
import Icon from 'components/elements/Icon'

import { useActions } from 'redux/hooks'
import { toggleModal as toggleModalAction } from 'redux/active/actions'

import { Button } from './style'

const Import = () => {
  const [toggleModal] = useActions(toggleModalAction)

  const openDeckEdit = () => toggleModal('massEditModal', true)

  return (
    <Button onClick={openDeckEdit}>
      <Icon name="pencil" link style={{ color: '#F79C00' }} size="massive" />
      <h4>Text Import</h4>
    </Button>
  )
}

export default Import
